import {Container, Row, Col, Button, Nav, Alert} from "react-bootstrap";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import TabContent from "./tab";
import {useDispatch} from "react-redux";
import {addItem} from "./../store.js";

function Detail(props) {
  let {id} = useParams();
  let [tab, setTab] = useState(0);
  let selproduct = props.shoes.find((x) => x.id == id);
  let [alert, setAlert] = useState(true);
  let [count, setCount] = useState(0);
  let [scale, setScale] = useState("");
  let dispatch = useDispatch();
  useEffect(() => {
    setTimeout(() => {
      setAlert(false);
    }, 2000);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setScale("end2");
    }, 50);
  }, []);

  return (
    <>
      <Container className={"start2 " + scale}>
        {alert === true ? <Alert variant="warning">2초이내 구매 시 할인</Alert> : null}
        <Row>
          <Col md={6}>
            <img src={"/img/shoes" + (Number(id) + 1) + ".jpg"} width="100%" />
          </Col>

          <Col md={6}>
            <h4 className="pt-5">{selproduct.title}</h4>
            <p>{selproduct.content}</p>
            <p>{selproduct.price}원</p>
            <Button
              className="btn btn-danger"
              onClick={() => {
                  dispatch(addItem({ id: selproduct.id, name: selproduct.title, count: 1 }));                  
              }}
            >
              주문하기
            </Button>
          </Col>
        </Row>
        <Nav variant="tabs" defaultActiveKey="/home">
          <Nav.Item>
            <Nav.Link
              eventKey="link-0"
              onClick={() => {
                setTab(0);
              }}
            >
              Tab1
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="link-1"
              onClick={() => {
                setTab(1);
              }}
            >
              Tab2
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="link-2"
              onClick={() => {
                setTab(2);
              }}
            >
              Tab3
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <TabContent tab={tab} />
      </Container>
    </>
  );
}

export default Detail;
